<template>
  <div>
    <title>快递打印记录</title>
     <section class="orderSect">
      <!--S 检索-->      
      <el-form :inline="true" :model="printFormInline">
        <el-form-item label="打印生成日期">
          <el-date-picker v-model="printFormInline.expressDate" type="daterange" range-separater="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="printFormInline.expressDateOptions"
          :unlink-panels = "true" clearable></el-date-picker>
        </el-form-item>
        <el-form-item label="订单号/快递单号" class="codeSerIpt">
          <el-input v-model="printFormInline.orderno" placeholder="请输入订单号/快递单号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPrintRecords">查询</el-button>
        </el-form-item>
      </el-form>
      <!--E 检索-->

      <!--S 快递打印列表-->
      <div class="allOrderTab">
        <el-table v-loading="loading" :data="expressPrintData" ref="expressTable" class="orderTable comTable" border :maxHeight="tableHeight" >     
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="打印生成日期" sortable prop="syncdate" min-width="180">
              <template slot-scope="scope">{{ dateTime(scope.row.syncdate, 1)}}</template>
            </el-table-column>
            <el-table-column label="打印数量" sortable prop="num" min-width="120">
              <template slot-scope="scope">{{scope.row.num}}</template>
            </el-table-column>
            <el-table-column label="操作人" sortable prop="expgenuname" min-width="180">
              <template slot-scope="scope">{{scope.row.expgenuname}}</template>
            </el-table-column>
            <el-table-column label="是否首次打印" sortable prop="bfirst" min-width="120">
              <template slot-scope="scope">{{scope.row.bfirst?'是':'否'}}</template>
            </el-table-column>
            <el-table-column label="重复打印备注" sortable prop="repeatmemo" min-width="200">
              <template slot-scope="scope"><p class="textFl" :title="scope.row.repeatmemo">{{scope.row.repeatmemo}}</p></template>
            </el-table-column>
            <el-table-column label="快递打印类型" sortable prop="expprinttype" min-width="150">
              <template slot-scope="scope">{{scope.row.expprinttype}}</template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
              <template slot-scope="scope">
                <router-link :title="scope.row.bank" :to="{name:'快递打印记录详情', params:{'expgenbatchno':scope.row.pbatchcode}}" class="blueColor">打印详情</router-link>
                <router-link v-if="scope.row.expgenbatchno" :to="{name:'快递打印记录批次详情', params:{'expgenbatchno':scope.row.expgenbatchno}}" class="blueColor">批次详情</router-link>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="noData"><span>暂无数据</span></div>
            </template>
        </el-table>
      </div>
      <!--S 快递打印列表-->
      <Page :pageTotal="pagebean.totalnum" :currentPage="pagebean.currentpage" @nowPageParam="setPageparam"></Page>
    </section>

    
    
    <!--S 完善快递弹窗组件-->
    <ImproveExpress :improveExpressBox="improveShow" :collectedShow="collected" @closeIEVal="clsBtnVal" @closeIEBox="closeImproveExpress"></ImproveExpress>
    <!--E 完善快递弹窗组件-->


  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import api from '../../apis/api';
import {dateTime} from '../../util/dateTime';
export default {
  name: 'ExpressPrintRecord',
  data () {
    return {
      printFormInline:{
        orderno: "", //订单号
        expressDate: "", //快递生成日期
        expressno:"", //快递单号
        expressDateOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime());
                picker.$emit("pick", [start, end]);
              }
            },{
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        },
      },
      expressPrintData:[],//打印列表数据
      multipleSelection: [], //已选中的行
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      seniorShow:false, //选择打印类别
      seniorForm:{
        printWay:'',
      },
      printWayList: [ //打印类别
        { value: "needleTypePrinting", label: "针式打印" },
        { value: "thermalSF", label: "顺丰热敏" },
        { value: "thermalJD", label: "京东热敏" },
        { value: "thermalYD", label: "韵达热敏" },
        { value: "thermalCN", label: "菜鸟热敏" },
        { value: "thermalAN", label: "安能热敏" },
        { value: "thermalKY", label: "跨越热敏" },
        { value: "chengNuoDa", label: "承诺达" },
      ],
      printType:'',//打印类别
      improveShow:false, //完善快递的弹窗
      improveEprBtnVal:'',//关闭完善快递弹窗是确定还是取消
      collected:false,//是否展示快递方式
      pagebean: {
        pagesize: 30,
        currentpage: 1
      },//分页
      loading: true,//加载
      expgenbatchno: '',
      patchName: '', // 获取上一个页面的name
    }
  },
  watch: {
    '$route'(to,from) {
      this.patchName = from.name;
    }
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    ImproveExpress: resolve => require(["@/components/DeliveryFolder/ImproveExpress.vue"], resolve), //完善快递组件
  },
  methods: {
    //表格多选选中行
    handleSelectionChange(val) { 
      this.multipleSelection = val;
      console.log(this.multipleSelection,'已勾选')
    },
    //非打印单号采集
    orderCollection(){
      if(this.multipleSelection.length > 0){ //勾选
        this.$router.push({
          name:'单号采集列表',
          params: {
            nonOddCollection:true, //是否展示快递方式
          }
        }); 
      }else{
        MessageBox.alert('请勾选你要采集单号的快递批次？', '系统提示', {
          confirmButtonText: '确定',
          type:'warning'
        }).then(() => {}).catch(() => {});
      } 
    },
    //勾选打印
    getPrinted(){
      if(this.multipleSelection.length > 0){ //勾选
        this.seniorShow = true; 
      }else{
        MessageBox.alert('请勾选你要打印的快递批次？', '系统提示', {
          confirmButtonText: '确定',
          type:'warning'
        }).then(() => {}).catch(() => {});
      } 
    },
    //打印类别选择
    printWaySel(){
      console.log(this.seniorForm.printWay,'123');
      this.printType = this.seniorForm.printWay;
    },
    //关闭打印类别弹窗
    closeSeniorBox(val){
      this.seniorShow = false;
      if(val){
        this.$router.push({
          name:'针式热敏打印列表',
          params: {
            printType: this.printType,
          }
        });
      }
    },
    //导出待发货、导出即发货
    exportSend(val){
      if(val){
        if(this.multipleSelection.length > 0){ //勾选
          //自动下载excel文件
          console.log('导出待发货下载excel文件');
        }else{
          MessageBox.alert('请勾选你要导出的快递批次？', '系统提示', {
            confirmButtonText: '确定',
            type:'warning'
          }).then(() => {}).catch(() => {});
        } 
      }else{ //导出即发货
        MessageBox.confirm('导出即发货直接将订单变为已发货且无法撤回无法采集单号，如需采集单号请用导出待发货操作，针对该批次有电商监管订单的强烈建议使用旁边的【导出待发货】功能。是否继续?', '信息确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //自动下载excel文件
           console.log('导出即发货下载excel文件');
        }).catch(() => {});;
      }
    },
    //完善快递
    improveExpress(){
      this.improveShow = true;
    },
    //关闭完善快递是确定还是取消
    clsBtnVal(val){
      this.improveEprBtnVal = val;
    },
    //关闭完善快递弹窗
    closeImproveExpress(){
      this.improveShow = false; //完善快递弹窗
      if(Number(this.improveEprBtnVal)){
        Message({
          type: 'success',
          message: '完善快递成功!'
        });
      }
    },
    //操作指令
    handleCommand(command) {
      if(command == 'expressDetail'){ //详情
        this.$router.push({name:'快递打印列表详情'});
      }else if(command == 'needleTypePrinting' || command == 'thermalSF' || command == 'thermalJD' || command == 'thermalYD' || command == 'thermalCN' || command == 'thermalAN' || command == 'thermalKY' || command == 'chengNuoDa'){ //打印  
        this.$router.push({
          name:'针式热敏打印列表',
          params: {
            printType: command,
          }
        });
      }else if(command == 'netShopERP'){ //网点管家ERP
        this.$router.push({name:'ERP发货记录'});  
      }else if(command == 'orderCollection'){ //单号采集
        this.$router.push({
          name:'单号采集列表',
          params: {
            nonOddCollection:false, //是否展示快递方式
          }
        });  
      }else if(command == 'ResetToIssued'){ //重置待发
        MessageBox.confirm('确定执行【重置待发】操作?', '信息确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          Message({  //失败提示
            type: 'error',
            message: '此批次中含有状态不符的快递，不能进行【重置待发】操作!'
          });
          // Message({  //成功提示
          //   type: 'success',
          //   message: '【重置待发】操作成功!'
          // });
        }).catch(() => {});
      }else if(command == 'exportShipped'){ //导出待发货
        //自动下载excel文件
        console.log('待发货下载excel文件');
      }else if(command == 'exportDelivery'){ //导出即发货
        MessageBox.confirm('导出即发货直接将订单变为已发货且无法撤回无法采集单号，如需采集单号请用导出待发货操作，针对该批次有电商监管订单的强烈建议使用旁边的【导出待发货】功能。是否继续?', '信息确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //自动下载excel文件
          console.log('即发货下载excel文件');
        }).catch(() => {});;
      }
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.expressTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
    },

    //设置分页数据
    setPageparam(nowPageSize, nowCurrentPage) {
      if(nowPageSize) {
        this.pagebean.pagesize = nowPageSize
      }
      if(nowCurrentPage) {
        this.pagebean.currentpage = nowCurrentPage
      }
      this.getPrintRecords()
    },

    //获取打印列表
    getPrintRecords() {
      this.loading = true
      let params = {
        stardate: this.printFormInline.expressDate && this.printFormInline.expressDate[0] ? this.dateTime(this.printFormInline.expressDate[0]) : '',
        enddate: this.printFormInline.expressDate && this.printFormInline.expressDate[1] ? this.dateTime(this.printFormInline.expressDate[1]) : '',
        orderno: this.printFormInline.orderno, //订单号
        pageparam: this.pagebean
      }
      api.GET_EXPPRINTRECORDLIST(params).then(res => {
        if(res.data.status == '200') {
          this.expressPrintData = res.data.data
          this.pagebean = res.data.pagebean
        } else {
          this.expressPrintData = []
        }
        this.loading = false
      })
    },

  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    //在dom渲染之后
    setTimeout(() => {
      this.getHeight();
      this.getPrintRecords()
    }, 200);
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  },
  activated() {
    if(this.patchName != '快递打印记录详情' && this.patchName != '快递打印记录批次详情') {
      if(this.patchName) {
        this.printFormInline.orderno = '';
        this.printFormInline.expressDate = '';
        this.printFormInline.expressno = '';
        this.pagebean = {
          pagesize: 30,
          currentpage: 1
        }
        setTimeout(() => {
          this.getHeight();
          this.getPrintRecords()
        }, 200);
      }
    }
  },
}
</script>

<style scoped>
@import "Css/Style.css";
.individualiz >>> form {padding-top:15px!important;}

/*选择打印方式*/
.seniorMdg >>> .el-dialog {width:500px;}
.seniorMdg >>> .el-form-item__content {width:65%; min-width: 200px; max-width: 340px;}
.seniorMdg >>> .el-form-item__content .el-select {width:100%;}

</style>



// WEBPACK FOOTER //
// src/views/DeliveryFolder/ExpressPrintRecord.vue